// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3cc7df90","453":"7a95b7ff","455":"71e84860"}[chunkId] + ".chunk.js";
};